module.exports = __webpack_public_path__ + "img/zendesk.c0d253f1.png";